// ManufacturingReadyMaterialReducer.js — Manufacturing tab > Ready
// Material page. Wired into rootReducer.js as `manufacturingReadyMaterials`.

const initialState = {
  readyMaterials: [],
  selectedBatch: null,
  loading: false,
  actionLoading: false,
  error: null
};

const ManufacturingReadyMaterialReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_READY_MATERIALS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_READY_MATERIALS_SUCCESS':
      return { ...state, loading: false, readyMaterials: action.payload, error: null };
    case 'FETCH_READY_MATERIALS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GET_READY_MATERIAL_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_READY_MATERIAL_SUCCESS':
      return { ...state, actionLoading: false, selectedBatch: action.payload };
    case 'GET_READY_MATERIAL_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CREATE_READY_MATERIAL_REQUEST':
    case 'DELETE_READY_MATERIAL_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_READY_MATERIAL_SUCCESS':
      return { ...state, actionLoading: false, readyMaterials: [action.payload, ...state.readyMaterials] };
    case 'DELETE_READY_MATERIAL_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        readyMaterials: state.readyMaterials.filter((r) => r.id !== action.payload)
      };

    case 'CREATE_READY_MATERIAL_FAILURE':
    case 'DELETE_READY_MATERIAL_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CLEAR_SELECTED_READY_MATERIAL':
      return { ...state, selectedBatch: null };

    default:
      return state;
  }
};

export default ManufacturingReadyMaterialReducer;
